/**
 * printUtils.js
 * Utility for opening pdfMake PDFs in a new browser tab.
 *
 * Modern browsers block window.open() after async operations (e.g. payment gateway callbacks).
 * To avoid this, the caller should pre-open a window reference (window.open('', '_blank'))
 * immediately inside the user gesture handler and pass it as targetWindow.
 * pdfMake then writes the PDF into that pre-opened tab without triggering popup blockers.
 */

/**
 * Opens a pdfMake document in a new browser tab.
 *
 * @param {object} pdfDoc - pdfMake document from pdfMake.createPdf(docDefinition)
 * @param {function} resolve - Promise resolve callback
 * @param {Window|null} targetWindow - Pre-opened window reference to avoid popup blocker
 */
export const openPdfInTab = (pdfDoc, resolve, targetWindow = null) => {
    try {
        if (targetWindow && !targetWindow.closed) {
            pdfDoc.open({}, targetWindow);
        } else {
            pdfDoc.open();
        }
        setTimeout(() => resolve(), 500);
    } catch (err) {
        console.warn("PDF preview could not open in new tab:", err);
        // Receipt is already saved in DB — resolve gracefully
        resolve();
    }
};
